import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../lib/pixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const baseClasses = `
    inline-flex items-center justify-center 
    bg-sage-700 text-cream font-medium tracking-wide
    px-8 py-4 rounded-xl shadow-sm hover:shadow-md hover:bg-sage-800
    transition-colors duration-300
    ${className}
  `;
  if (href) {
    return <motion.a whileHover={{
      y: -2
    }} whileTap={{
      y: 0
    }} href={href} onClick={() => trackAddToCart()} className={baseClasses} data-id="element-363">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    y: -2
  }} whileTap={{
    y: 0
  }} onClick={onClick} className={baseClasses} {...props} data-id="element-364">
      {children}
    </motion.button>;
}